import { ColumnDef, ColumnHelper } from '@tanstack/react-table'
import { Preferences } from 'models/preferences'
import { DataTableColumnSort } from '../../../../DataTable/DataTableSorting/DataTableSortingStore'
import {
  DistributorsCell,
  GPOsCell,
  TaglistCell,
} from '../../../../FbUI/StagePill'
import { DOOR_CRM_REPORT_COLUMNS } from './DoorCRMReportColumnsInfo'
import { createTableColumnHelper } from '../../commonColumnHelpers'
import { DoorProxyReport } from 'models/door_reports'

export function getCommonDoorCRMReportColumns(
  columnHelper: ColumnHelper<DoorProxyReport>,
  sorting?: DataTableColumnSort[],
  preferences?: Preferences
) {
  const tooltips: Record<string, unknown> = preferences?.tooltips || {}
  const doorsColumnHelper = createTableColumnHelper({
    columns: DOOR_CRM_REPORT_COLUMNS,
    tooltips,
  })

  const cols: ColumnDef<DoorProxyReport, any>[] = [
    // Door CRM Report taglist
    columnHelper.accessor('door_crm_report.taglist', {
      ...doorsColumnHelper.retrieveColumn('door_taglist'),
      size: 200,
      cell: (info) => {
        return (
          <TaglistCell
            taglistIds={
              info.row.original.door_crm_report?.taglist.map((it) => it.id!) ??
              []
            }
            asc={
              sorting?.length && sorting[0].id === 'door_taglist'
                ? !sorting[0].desc
                : undefined
            }
          />
        )
      },
    }),

    // Door CRM Report distributors
    columnHelper.accessor('door_crm_report.distributors', {
      ...doorsColumnHelper.retrieveColumn('door_distributors'),
      size: 200,
      cell: (info) => {
        return (
          <DistributorsCell
            distributorsIds={
              info.row.original.door_crm_report?.distributors.map(
                (it) => it.id!
              ) ?? []
            }
            asc={
              sorting?.length && sorting[0].id === 'door_distributors'
                ? !sorting[0].desc
                : undefined
            }
          />
        )
      },
    }),

    // Door CRM Report gpos
    columnHelper.accessor('door_crm_report.gpos', {
      ...doorsColumnHelper.retrieveColumn('door_gpos'),
      size: 200,
      cell: (info) => {
        return (
          <GPOsCell
            gposIds={
              info.row.original.door_crm_report?.gpos.map((it) => it.id!) ?? []
            }
            asc={
              sorting?.length && sorting[0].id === 'door_gpos'
                ? !sorting[0].desc
                : undefined
            }
          />
        )
      },
    }),
  ]

  return cols
}
